import { Component, inject } from '@angular/core';
import { FlowSessionService } from './services/flow-session.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'alf-nx-workspace-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  private readonly flowSessionService = inject(FlowSessionService);
  private readonly router = inject(Router);

  ngOnInit() {
    if(!this.flowSessionService.isLoggedIn()) {
      sessionStorage.setItem('alfresco-redirect-url', window.location.href);
    } else {
      const redirectUrl = sessionStorage.getItem('alfresco-redirect-url');
      if(redirectUrl) {
        sessionStorage.removeItem('alfresco-redirect-url');
        const url = new URL(redirectUrl);
        const pathWithQuery = url.pathname + url.search;
        this.router.navigateByUrl(pathWithQuery);
      }
      this.flowSessionService.start();
    }

  }
}
